var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iw"},[_c('img',{staticClass:"iw__icon",attrs:{"src":require("@/assets/img/icons/info-gray.svg"),"alt":"","tabindex":"-1"}}),_c('span',{staticClass:"iw__text",domProps:{"textContent":_vm._s(_vm.$ml.get('installmentSupportText'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }